export type EventRouteParams = {
  eventId: string
}

export enum VirtualEventStatus {
  Draft,
  Published,
}

export type VirtualEventDetails = {
  allowParticipantsToJoinWaitList: boolean
  allowParticipantsToSelfBook: boolean
  categoryId: string
  createdBy: string
  createdDate: string
  description: string
  enableRecordingDownload: boolean
  eventStatus: VirtualEventStatus
  maximumParticipants: number
  publishedDate: string
  title: string
  updatedBy: string
  updatedDate: string
}

export type VirtualEventCategory = {
  categoryId: Nullable<Guid>
  inUse: boolean
  name: string
  parentId: Nullable<Guid>
  sortCode: number
}

export enum VirtualEventRole {
  None,
  Listener, // Participant
  Presenter,
  Host,
}

export type EventCategoriesResponse = VirtualEventCategory[]

export type BaseVirtualEvent = {
  id: Guid
  categoryId: Guid
  title: string
  description: string
  createdDate: DateTime
  updatedDate: DateTime
  createdBy: string
  updatedBy: string
  maximumParticipants: number
  allowParticipantsToJoinWaitList: boolean
  allowParticipantsToSelfBook: boolean
  eventStatus: VirtualEventStatus
}
